module.exports = {
  en: 'en',
  da: 'da',
  nl: 'nl',
  fr: 'fr',
  de: 'de',
  it: 'it',
  no: 'no',
  ru: 'ru',
  sv: 'sv',
  es: 'es',
  pt: 'pt_BR',
}
